var _radialGradient, _linearGradient, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwedenLotto2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "a",
    cx: 15.909,
    cy: 20.359,
    r: 7.739,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.183,
    stopColor: "#c00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d50000"
  }))), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 0,
    y1: 0.503,
    x2: 1.25,
    y2: 0.503
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffa7b0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d50000"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.923 34.574h84.154c1.599 0 2.919 1.32 2.919 2.937v24.978c0 1.617-1.311 2.937-2.919 2.937H7.923c-1.599 0-2.919-1.32-2.919-2.937V37.502c.009-1.608 1.32-2.928 2.919-2.928z",
    fill: "#008300"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.831 42.884h8.58c1.218 0 1.813.948 1.794 1.878-.028.892-.623 1.766-1.794 1.766h-2.37v9.286c0 2.556-3.839 2.556-3.839 0v-9.286h-2.37c-1.19 0-1.785-.911-1.785-1.813-.009-.92.586-1.831 1.785-1.831zm12.968 0h8.571c1.227 0 1.822.948 1.794 1.878-.028.892-.623 1.766-1.794 1.766H72v9.286c0 2.556-3.839 2.556-3.839 0v-9.286H65.8c-1.199 0-1.794-.911-1.794-1.813 0-.92.604-1.831 1.794-1.831zM32.594 54.076h4.072a1.82 1.82 0 0 1 1.803 1.71 1.816 1.816 0 0 1-1.803 1.924h-3.309l-2.054.009c-.521 0-1.004.019-1.292-.093a1.943 1.943 0 0 1-1.255-1.813V44.808a1.94 1.94 0 0 1 1.961-1.934 1.934 1.934 0 0 1 1.878 1.934v9.268zm12.168-11.22c-3.96 0-7.167 3.337-7.167 7.464s3.207 7.464 7.167 7.464 7.176-3.337 7.176-7.464-3.216-7.464-7.176-7.464zm0 11.517c-1.552 0-2.798-1.813-2.798-4.053s1.255-4.053 2.798-4.053 2.798 1.813 2.798 4.053-1.255 4.053-2.798 4.053zM82.67 42.856c-3.96 0-7.176 3.337-7.176 7.464s3.207 7.464 7.176 7.464c3.96 0 7.167-3.337 7.167-7.464s-3.207-7.464-7.167-7.464zm0 11.517c-1.552 0-2.798-1.813-2.798-4.053s1.246-4.053 2.798-4.053c1.543 0 2.798 1.813 2.798 4.053s-1.255 4.053-2.798 4.053z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m25.985 43.684-.651-.725v14.743h.651z",
    fill: "#573301"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m25.985 58.417-14.622.037-.697-.706V43.86l.632-.902 14.687 14.743z",
    fill: "#1e5403"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.297 42.958h14.027v14.734H11.297z",
    fill: "url(#a)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.297 42.958h14.027v1.422H11.297z",
    fill: "url(#b)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.297 42.958h14.027v.716H11.297zm7.781 7.818a1.692 1.692 0 0 1 1.683 1.701 1.692 1.692 0 0 1-1.683 1.701 1.694 1.694 0 0 1-1.692-1.701 1.701 1.701 0 0 1 1.692-1.701zm-4.202-3.616s-.967 1.58-.604 4.462c.363 2.91 2.64 4.332 4.536 4.443 1.896.102 2.677-.409 3.746-1.292s1.534-2.184 1.534-2.184.511 3.003-1.608 5.103h-8.571s-1.357-1.422-1.274-5.131c.093-3.709 2.24-5.401 2.24-5.401z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwedenLotto2);
export default __webpack_public_path__ + "static/media/sweden_lotto_2.83a87223d98eaa4b11fe862483366f63.svg";
export { ForwardRef as ReactComponent };